import { FC } from 'react'
import * as cn from 'classnames'
import * as styles from 'components/features/pfm/Tooltip/ShareButtonTooltip.styl'
import Tooltip, { TooltipDirection } from 'components/features/pfm/Tooltip/Tooltip'
import SvgIcon from 'components/atoms/SvgIcon'
import ReactSvgIcon from 'icons/*.svg'
import CopyIcon from 'icons/share_copy.svg'
import FacebookIcon from 'icons/share_facebook.svg'
import EmailIcon from 'icons/share_email-filled.svg'
import TwitterIcon from 'icons/share_twitter.svg'

export type FeedShareMethod = 'copy' | 'facebook' | 'twitter' | 'email'
type Option = {
  id: FeedShareMethod
  iconSrc: typeof ReactSvgIcon | null
  text: string
}

const OPTIONS: Option[] = [
  // TODO: change `copy` and `email` icons to actual once
  { id: 'copy', iconSrc: CopyIcon, text: 'Copy Link' },
  { id: 'facebook', iconSrc: FacebookIcon, text: 'Post' },
  { id: 'twitter', iconSrc: TwitterIcon, text: 'Tweet' },
  { id: 'email', iconSrc: EmailIcon, text: 'Email' },
]

type ShareButtonTooltipProps = {
  linkCopied: boolean
  onShare: (method: FeedShareMethod) => void
  direction: TooltipDirection
}

export const ShareButtonTooltip: FC<ShareButtonTooltipProps> = (props) => {
  const { linkCopied, onShare, direction } = props

  const optionChildren = OPTIONS.map((option) => {
    const { id, iconSrc, text: optionText } = option

    const text = id === 'copy' && linkCopied ? 'Copied' : optionText

    return (
      <button
        key={ id }
        className={ cn(styles.option, styles[option.id]) }
        onClick={ () => onShare(option.id) }
      >
        <div className={ styles.iconWrapper }>
          <SvgIcon src={ iconSrc } />
        </div>
        <div className={ styles.text }>{ text }</div>
      </button>
    )
  })

  return (
    <Tooltip
      theme='white'
      direction={ direction }
    >
      <div className={ styles.optionsWrapper }>
        { optionChildren }
      </div>
    </Tooltip>
  )
}
